import moment from 'moment';

function _extraDataForPatient(p) {
  if (!p) return {};
  return (p && p.extraData) || {};
}
function _deploymentInfoForPatient(p) {
  const extraData = _extraDataForPatient(p);
  return extraData.deployment || {};
}

export function currentImmunizationsForPatient(p) {
  if (!p) return {};

  const extraData = _extraDataForPatient(p);
  return extraData.immunizations || {};
}
export function currentDeploymentInfoForPatient(p) {
  if (!p) return {};

  const deploymentInfo = _deploymentInfoForPatient(p);

  const deploymentDate = deploymentInfo.date;
  const deploymentLocation = deploymentInfo.location;

  if (!deploymentDate || !deploymentLocation) return {};

  const endOfDeploymentDay = moment(deploymentDate).endOf('day');
  const nowMoment = moment();
  const isPast = nowMoment.isAfter(endOfDeploymentDay);

  if (isPast) return {};

  return deploymentInfo;
}

// only return pha if due date is in the future, or due date is in the past
// and it still hasn't been approved
export function currentPHAInfoForPatient(p) {
  if (!p) return {};
  const phaInfo = p?.extraData?.pha;
  const dueDate = phaInfo?.dueDate;
  if (!dueDate) return {};

  const endOfDueDay = moment(dueDate).endOf('day');
  const nowMoment = moment();
  const isPast = nowMoment.isAfter(endOfDueDay);

  if (isPast && phaInfo?.approvedDate) return {};

  return {
    ...phaInfo,
    isPast,
  };
}
